<template>
    <div class="layout-upload">
        <div :class="[isDesktop ? 'desktop-layout-upload': 'mobile-layout-upload']">
          <div class="upload-box"> 
            <el-upload class="upload-demo" ref="uploadRef" :webkitdirectory="false"
                :mozdirectory="false" :file-list="uploadFiles" :drag="isDesktop" :auto-upload="false" :show-file-list="false"
                accept="application/pdf,application/x-subrip,application/octet-stream,text/plain" action=""
                :multiple="false" :on-change="handleUploadFile">
                <ClientOnly>
                  <div class="upload-content">
                      <i class="iconfont icon-icon_upload5" />
                      <div class="upload-content-title">
                          {{$t('editor_home_upload_title') }}
                      </div>
                      <div class="upload-content-or">
                          {{$t('editor_home_upload_or') }}
                      </div>
                      <div class="upload-content-btn">
                          {{$t('editor_home_upload_btn') }}
                      </div>
                      <div class="upload-content-tips" v-if="homePageConfig.maxFileSize">
                          {{$t('editor_home_upload_size').replace('*', homePageConfig.maxFileSize) }}
                      </div>
                  </div>
                  <div class="click-blocker" @click.prevent.stop="showClickMessage"></div>
                </ClientOnly>
            </el-upload>
          </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import useBasicStore from '~/store/modules/basic'
import useSystemLaunageStore from '~/store/modules/systemLaunage'
import CommonImage from '~/components/CommonImage/CommonImage.vue'
import { getMD5FileString } from '@/utils/init';
import { EventHomeMessage } from '~/config/event';
import Toast from '@/utils/toast';
import eventBus from 'vue3-eventbus';
const viewport = useViewport()
const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'))
const basicStore = useBasicStore()
const { isChina, homePageConfig } = storeToRefs(basicStore)
const systemLanguageStore = useSystemLaunageStore()
const { systemLanguage } = storeToRefs(systemLanguageStore)
const { t } = useI18n()
let uploadFiles = ref([])
let uploadRef = ref()

function showClickMessage (event: any) {
    event.preventDefault();
    event.stopPropagation();
    console.log(event, 'event')
}

// async function handleBeforeUpload (file) {
//     const drag = isDrag.value
//     console.log(drag, 'drag')
//     if (!drag) { // 如果不是拖拽上传，则阻止上传
//       return false
//     }
//     return true; // 允许文件上传
// }

async function handleUploadFile (file, files) {
  console.log(file, files, 'file, files')

  const fileSize = file.size / 1000 / 1000
  const maxSize = homePageConfig.value.maxFileSize as number
  console.log(fileSize, maxSize, 'fileSize, maxSize')

  if (fileSize > maxSize) {
    uploadFiles.value = [];
    Toast(t('uploadFileSizeTips') + `${maxSize}M`)
    return
  }

  if (file.raw.name.toLowerCase().endsWith('.pdf') ) {
    // let fileMD5 = await getMD5FileString(file)
    
    eventBus.emit(EventHomeMessage.uploadFileClick, { file: file.raw })
    uploadFiles.value = []
  }else {
    Toast(t('uploadFileFormatTips'))
    uploadFiles.value = [];
  }
}

onMounted(() => {
//   const uploadElement = uploadRef.value?.$el
//   if (uploadElement) {
//     const dragger = uploadElement.querySelector('.el-upload-dragger')
//     console.log(dragger, 'uploadRef')
//     if (dragger) {
//       // 克隆元素并替换，移除所有事件监听器
//       const newDragger = dragger.cloneNode(true)
//       dragger.parentNode.replaceChild(newDragger, dragger)
      
//       // 添加样式
//       newDragger.style.pointerEvents = 'none'
//       newDragger.style.cursor = 'default'
//     }
//   }
})

</script>

<style scoped lang="scss">
@use "./index.scss" as *;
@use "./mobile.scss" as *;


</style>
